import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newTarrif() {
    let tarrifDetails = {
      tarrif_category: $(".tarrif_category").val(),
      item_name: $(".item_name").val()
    };
    $(".creatingTarrif").hide();
    $(".creatingTarrifLoader").show();
    baseurl.post(rt.newTarrif, tarrifDetails).then(res => {
      $(".creatingTarrif").show();
      $(".creatingTarrifLoader").hide();
      $(".form-control").val("");

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.tarrifCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //item name exits
        ers.TarrifExists();
      } else if (res.data.code === 404) {
        //error on inserting data
        ers.errorCreatingTarrif();
      } else if (res.data.code === 405) {
        //no permission to insert
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadTarrif({ commit }) {
    baseurl.get(rt.loadTarrifs).then(res => {
      $(".tarrifLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code and mutations
        commit("STORE_TARRIFS", res.data.tarrifs);
      } else if (res.data.code === 404) {
        //error loading data
        ers.errorLoadingTarrif();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        commit("STORE_TARRIFS", []);
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  tarrifUpdate({ commit }) {
    let tarrifDetails = {
      id: $(".id").val(),
      tarrif_category: $(".tarrif_category").val(),
      item_name: $(".item_name").val()
    };
    $(".updatingTarrif").hide();
    $(".updatingTarrifLoader").show();
    baseurl.post(rt.updateTarrif, tarrifDetails).then(res => {
      $(".updatingTarrif").show();
      $(".updatingTarrifLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //sucess code
        suc.tarrifUpdateSuccess();
        commit("STORE_TARRIFS", res.data.tarrifs);
        setTimeout(() => {
          router.push("/managetarrifs");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating data
        ers.errorUpdatingTarrif();
      } else if (res.data.code === 405) {
        //no permisison to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewTarrif({ commit }, tarrifId) {
    commit("STORE_TARRIF_UPDATE", tarrifId);
    router.push("/updatetarrif");
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/tarrifs/actions.js